import { styled } from '@material-ui/core';
import { Tooltip } from 'app/components/BasicTooltips/Tooltip';
import {
  selectAppSettings,
  selectAuthenticatedUser,
  selectEventsCount,
  selectEventsCountLoading,
} from 'app/slice/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from 'app/components/BasicIcons/FontAwesome';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { useSystemDate } from 'app/hooks/useSystemDate';
import { bookitColors } from 'styles/colors/bookitColors';
import { dateUtils } from 'utils/date-utils';
import { Roles } from 'app/slice/types';
import { IsModuleEnabled } from 'types/AppSettings';
import { KnownModules } from 'types/KnownModules';
import { IconButton } from 'app/components/BasicButtons/IconButton';
export interface EventsCountProps {}

export const EventsCount = React.memo(function EventsCount(
  props: EventsCountProps,
) {
  const count = useSelector(selectEventsCount);
  const { t } = useTranslation();
  const { newDate } = useSystemDate();
  const user = useSelector(selectAuthenticatedUser);
  const eventsLoading = useSelector(selectEventsCountLoading);
  const isAdmin = React.useMemo(() => {
    return (
      user !== undefined &&
      (user.Roles.indexOf(Roles.Administrators) >= 0 ||
        user.Roles.indexOf(Roles.GroupAdministrators) >= 0 ||
        user.Roles.indexOf(Roles.LabTech) >= 0 ||
        user.Roles.indexOf(Roles.InstrumentEventsAdmin) >= 0)
    );
  }, [user]);

  const appSettings = useSelector(selectAppSettings);
  const isMaintenanceAssetsEnabled = IsModuleEnabled(
    appSettings,
    KnownModules.MaintenanceAssets,
  );

  const StyledSpanIcon = styled('span')(({ theme }) => ({
    fontSize: '20px',
    color: bookitColors.grayscale.graySubtitles,
    width: '20px',
    height: '20px',
  }));

  //RENDER
  return isAdmin && isMaintenanceAssetsEnabled && !eventsLoading ? (
    <IconButton
      variant="ghost"
      size="small"
      aria-label="search"
      to={`/workorders?openedOnly=false&period=0&et=${dateUtils.formatQueryStringDate(
        newDate(),
      )}`}
      title={t(translations.Alerts)}
      shape="square"
    >
      <Tooltip title={t(translations.Alerts) as string}>
        <StyledSpanIcon className="fa-layers fa-fw">
          <Icon icon={['fas', 'tools']} />
          <span
            className="fa-layers-counter"
            style={{
              whiteSpace: 'nowrap',
              fontSize: '26px',
              right: '-4px',
              top: '-4px',
            }}
          >
            {count}
          </span>
        </StyledSpanIcon>
      </Tooltip>
    </IconButton>
  ) : null;
});
